export default __webpack_public_path__ + "static/media/key_features_easy_installation.d2b73456.svg";